import r from"react";import{useStyles as t}from"tss-react";var e=function(e){var i=e.children,a=e.width,c=void 0===a?"100%":a,d=t().css;return r.createElement("div",{className:d({padding:"20px",width:c})},i)};export{e as TooltipContent};
//# sourceMappingURL=tooltipContent.js.map
